import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import logger from "../../utils/logging";

interface ModalLoadingProps {
    show: boolean;
    title: string;
    message: string;
    onClose?: () => void;
}

const ModalLoading: React.FC<ModalLoadingProps> = ({ show, title, message, onClose }) => {
    const { t } = useTranslation("common");
    logger.debug("show modal");
    return (
        <>
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">{t("loading")}</span>
                    </Spinner>
                    <p>{message}</p>
                </Modal.Body>
                {onClose && (
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onClose}>
                            {t("buttons.close")}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </>
    );
};

export default ModalLoading;
